module.exports = __webpack_public_path__ + "static/media/IMG_0545.e10c4fd6.jpg";